import queueConstants from "@/constants/queueConstants"

const pages = {
  settingsPage() {
    return {
      name: "Queue Settings",
      i18n_name_key: "sidebar_items.queue_settings",
      path: queueConstants.PATHS.SETTINGS,
      roles: queueConstants.QUEUE_ADMIN_ROLES,
      module: queueConstants.MODULE,
      dependency: queueConstants.ROUTE_DEPENDENCY.SETTINGS,
      helpKey: "queue_settings_v002"
    }
  }
}

export default {
  pages
}
